import { PartnerUsersModule } from './../../../partner/partner-users/partner-users.module';
import { Routes } from '@angular/router';
import {checkRoleGuard} from '../../../../core/guards/check-role.guard';

export const PARTNER_ROUTERS: Routes = [

  {
    path: '',
    redirectTo: 'vale-pedagio',
    pathMatch: 'full',
  },
  {
    path: 'vale-pedagio',
    loadChildren: () =>
      import(
        '@modules/partner/toll-voucher-partners/toll-voucher-partners.module'
      ).then((m) => m.TollVoucherPartnersModule),
    canActivate: [checkRoleGuard],
    data: {
      roles: '103004',
      contractRequired: false,
    },
  },
  {
    path: 'faturas',
    loadChildren: () =>
      import('@modules/partner/invoices-partner/invoices-partner.module').then(m => m.InvoicesPartnerModule),
    canActivate: [checkRoleGuard],
    data: {
      roles: '103004',
      contractRequired: false,
    },
  },
  {
    path: 'minha-conta',
    loadChildren: () =>
      import(
        '@modules/partner/partner-account/partner-account.module'
      ).then((m) => m.PartnerAccountModule),
    canActivate: [checkRoleGuard],
    data: {
      roles: '101135',
      contractRequired: false,
    },
  },
  {
    path: 'usuarios',
    loadChildren: () =>
      import(
        '@modules/partner/partner-users/partner-users.module'
      ).then((m) => m.PartnerUsersModule),
    canActivate: [checkRoleGuard],
    data: {
      roles: '103007',
      contractRequired: false,
    },
  },
];
